// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  adapted from:
  https: //piccalil.li/blog/a-modern-css-reset/
  https://www.joshwcomeau.com/css/custom-css-reset/
*/
@layer base {
  html,
  body {
    height: 100%;
  }
  header-app-root > section {
    border-bottom-color: white !important;
  }
  body {
    margin: 0;
    padding: 0;
  }
  app-root {
    height: 100%;
    isolation: isolate;
    line-height: 1.5;
    text-rendering: optimizeSpeed;
    -webkit-font-smoothing: antialiased;
    display: block;
    min-width: 320px;
    /* Remove list styles on ul, ol elements with a list role due to webkit semantic issues */
  }
  app-root *,
  app-root *::before,
  app-root *::after {
    box-sizing: border-box;
  }
  app-root h1,
  app-root h2,
  app-root h3,
  app-root h4,
  app-root p,
  app-root figure,
  app-root blockquote,
  app-root ul,
  app-root ol,
  app-root dl,
  app-root dd,
  app-root menu,
  app-root fieldset,
  app-root input,
  app-root button,
  app-root a {
    margin: 0;
    padding: 0;
  }
  app-root ul[role='list'],
  app-root ol[role='list'],
  app-root menu[role='list'] {
    list-style: none;
  }
  app-root ul[role='list'] li,
  app-root ol[role='list'] li,
  app-root menu[role='list'] li {
    display: inline-block;
  }
  app-root label {
    display: inline-block;
  }
  app-root:focus-within {
    scroll-behavior: smooth;
  }
  app-root img,
  app-root picture {
    display: block;
    max-width: 100%;
    height: auto;
  }
  app-root input,
  app-root button,
  app-root textarea,
  app-root select {
    font: inherit;
  }
  app-root fieldset {
    border: none;
  }
  app-root p,
  app-root h1,
  app-root h2,
  app-root h3,
  app-root h4,
  app-root h5,
  app-root h6,
  app-root li,
  app-root dl,
  app-root dt,
  app-root blockquote {
    overflow-wrap: break-word;
  }
  @media (prefers-reduced-motion: reduce) {
    app-root *,
    app-root *::before,
    app-root *::after {
      animation: none !important;
      transition: none !important;
    }
    app-root:focus-within {
      scroll-behavior: auto;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/Styles/modest-reset.less"],"names":[],"mappings":"AAAA;;;;CAIC;AACD;EACE;;IAEE,YAAA;EACF;EAEA;IACE,qCAAA;EAAF;EAGA;IACE,SAAA;IACA,UAAA;EADF;EAIA;IACE,YAAA;IACA,kBAAA;IACA,gBAAA;IACA,6BAAA;IACA,mCAAA;IACA,cAAA;IACA,gBAAA;IAFA,yFAAyF;EAC3F;EANA;;;IAYI,sBAAA;EADJ;EAXA;;;;;;;;;;;;;;;;IA+BI,SAAA;IACA,UAAA;EAFJ;EA9BA;;;IAuCI,gBAAA;EAJJ;EAnCA;;;IA0CM,qBAAA;EAFN;EAxCA;IA+CI,qBAAA;EAJJ;EAOE;IACE,uBAAA;EALJ;EA9CA;;IAwDI,cAAA;IACA,eAAA;IACA,YAAA;EANJ;EApDA;;;;IAiEI,aAAA;EAPJ;EA1DA;IAqEI,YAAA;EARJ;EA7DA;;;;;;;;;;;IAmFI,yBAAA;EATJ;EAYE;IAAA;;;MAII,0BAAA;MACA,2BAAA;IAVJ;IAYE;MACE,qBAAA;IAVJ;EACF;AACF","sourcesContent":["/*\n  adapted from:\n  https: //piccalil.li/blog/a-modern-css-reset/\n  https://www.joshwcomeau.com/css/custom-css-reset/\n*/\n@layer base {\n  html,\n  body {\n    height: 100%;\n  }\n\n  header-app-root > section {\n    border-bottom-color: white !important;\n  }\n\n  body {\n    margin: 0;\n    padding: 0;\n  }\n\n  app-root {\n    height: 100%;\n    isolation: isolate;\n    line-height: 1.5;\n    text-rendering: optimizeSpeed;\n    -webkit-font-smoothing: antialiased;\n    display: block;\n    min-width: 320px;\n\n    *,\n    *::before,\n    *::after {\n      box-sizing: border-box;\n    }\n\n    h1,\n    h2,\n    h3,\n    h4,\n    p,\n    figure,\n    blockquote,\n    ul,\n    ol,\n    dl,\n    dd,\n    menu,\n    fieldset,\n    input,\n    button,\n    a {\n      margin: 0;\n      padding: 0;\n    }\n\n    /* Remove list styles on ul, ol elements with a list role due to webkit semantic issues */\n    ul[role='list'],\n    ol[role='list'],\n    menu[role='list'] {\n      list-style: none;\n\n      li {\n        display: inline-block;\n      }\n    }\n\n    label {\n      display: inline-block;\n    }\n\n    &:focus-within {\n      scroll-behavior: smooth;\n    }\n\n    img,\n    picture {\n      display: block;\n      max-width: 100%;\n      height: auto;\n    }\n\n    input,\n    button,\n    textarea,\n    select {\n      font: inherit;\n    }\n\n    fieldset {\n      border: none;\n    }\n\n    p,\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6,\n    li,\n    dl,\n    dt,\n    blockquote {\n      overflow-wrap: break-word;\n    }\n\n    @media (prefers-reduced-motion: reduce) {\n      *,\n      *::before,\n      *::after {\n        animation: none !important;\n        transition: none !important;\n      }\n      &:focus-within {\n        scroll-behavior: auto;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
